import { useSettings } from "@/context/SettingsContext";
import { ABOUT_IMAGE, fileUrl } from "@/lib/api";
import { PageTitle } from "@/components/site/ReleaseCard";
import { SocialLinks } from "@/components/site/Social";

export default function About() {
  const { settings } = useSettings();
  return (
    <div data-testid="about-page">
      <PageTitle over="Chi siamo" title={settings.about_title || "Chi siamo"} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.2fr_1fr] gap-14 items-start">
        <div className="space-y-10">
          <p className="text-base md:text-lg leading-relaxed text-zinc-300 whitespace-pre-line" data-testid="about-text">{settings.about_text}</p>
          <div className="border-l-2 border-emerald-500 pl-6">
            <p className="font-mono-tga text-[10px] uppercase tracking-[0.3em] text-emerald-400 mb-3">Missione</p>
            <p className="font-display text-xl sm:text-2xl uppercase tracking-tight leading-snug" data-testid="about-mission">{settings.mission}</p>
          </div>
          <div className="space-y-3">
            <p className="font-mono-tga text-[10px] uppercase tracking-[0.3em] text-zinc-500">Seguici</p>
            <SocialLinks prefix="about-social" />
          </div>
        </div>
        <div className="relative">
          <img src={fileUrl(settings.about_image) || ABOUT_IMAGE} alt="Studio" className="w-full aspect-[4/5] object-cover border border-white/10" />
          <span className="absolute -bottom-5 -left-5 bg-emerald-500 text-black font-mono-tga text-xs tracking-[0.2em] px-4 py-3">www.thegrooveanomalyrecords.com</span>
        </div>
      </div>
    </div>
  );
}
